module.exports = __webpack_public_path__ + "img/Krammer Christopher.jpg";